import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    motoaMapsInitCallback?: () => void;
    mAPI?: string;
    google?: typeof google;
  }
}

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsLoaderService {
  private loadPromise: Promise<void> | null = null;

  load(): Promise<void> {
    if (window.google?.maps) {
      return Promise.resolve();
    }

    if (this.loadPromise) {
      return this.loadPromise;
    }

    const apiKey = this.resolveApiKey();
    if (!apiKey) {
      return Promise.reject(new Error('Google Maps API key is not configured'));
    }

    this.loadPromise = new Promise<void>((resolve, reject) => {
      const callbackName = 'motoaMapsInitCallback';
      window.motoaMapsInitCallback = () => {
        delete window.motoaMapsInitCallback;
        window.mAPI = apiKey;
        resolve();
      };

      const script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.src =
        `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}` +
        `&libraries=places&callback=${callbackName}`;
      script.onerror = () => {
        delete window.motoaMapsInitCallback;
        this.loadPromise = null;
        reject(new Error('Failed to load Google Maps JavaScript API'));
      };
      document.head.appendChild(script);
    });

    return this.loadPromise;
  }

  isReady(): boolean {
    return !!window.google?.maps;
  }

  private resolveApiKey(): string {
    return (
      localStorage.getItem('googleMapsApiKey') ||
      environment.googleMapsApiKey ||
      window.mAPI ||
      ''
    ).trim();
  }
}
